import { AccountBalance as BankIcon, CreditCard as CreditCardIcon } from '@mui/icons-material';

import { PaymentMethodListItem } from '../../apis/paymentMethodApi';

interface PaymentMethodTypeIconProps {
  paymentMethod: PaymentMethodListItem;
  isSmall?: boolean;
}

function PaymentMethodTypeIcon({ paymentMethod, isSmall }: PaymentMethodTypeIconProps) {
  const cardBrandsWithIcons = ['visa', 'mastercard', 'amex', 'discover', 'diners'];

  return (
    <>
      {paymentMethod.paymentType === 'card' ? (
        cardBrandsWithIcons.includes(paymentMethod.accountBrand) ? (
          <img width={isSmall ? 30 : 35} src={`/static/img/${paymentMethod.accountBrand}.png`} alt={paymentMethod.accountBrand} />
        ) : (
          <CreditCardIcon sx={{ fontSize: isSmall ? 30 : 35, color: (theme) => theme.palette.action.active }}></CreditCardIcon>
        )
      ) : (
        <BankIcon sx={{ fontSize: isSmall ? 26 : 30, color: (theme) => theme.palette.action.active }}></BankIcon>
      )}
    </>
  );
}

export default PaymentMethodTypeIcon;
